import { render } from "./OfMenu.vue?vue&type=template&id=e1cc18d6"
import script from "./OfMenu.vue?vue&type=script&lang=js"
export * from "./OfMenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\anda\\Documents\\onlinefundraising\\of_spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__